<template>
  <v-main class="login-bg">
    <div class="login-animated-bg">
      <div v-for="i in 8" :key="i" class="bubble" :style="bubbleStyle(i)" />
    </div>

    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="5" lg="4">
          <v-card class="pa-2 glass-card rounded-xl" elevation="20">
            <!-- Logo y nombre del gimnasio -->
            <v-card-text class="text-center pb-0 pt-5">
              <div class="mb-4">
                <v-avatar size="72" class="elevation-6" v-if="logo">
                  <img :src="logo" style="object-fit:contain;" />
                </v-avatar>
                <v-icon v-else size="72" color="primary">mdi-dumbbell</v-icon>
              </div>
              <div class="text-h5 font-weight-black primary--text mb-1">{{ nombreGimnasio || 'GymPro' }}</div>
              <div class="text-caption grey--text mb-2">Sistema de Gestión de Gimnasio</div>
            </v-card-text>

            <!-- ── PASO 1: Usuario + Contraseña ── -->
            <v-card-text v-if="!requiere2FA" class="px-4 py-3">
              <v-form ref="form" @submit.prevent="iniciarSesion">
                <v-text-field
                  v-model="usuario"
                  label="Usuario"
                  outlined rounded
                  prepend-inner-icon="mdi-account"
                  :disabled="cargando"
                  autofocus
                  hide-details class="mb-3"
                />
                <v-text-field
                  v-model="password"
                  label="Contraseña"
                  outlined rounded
                  prepend-inner-icon="mdi-lock"
                  :type="mostrarPassword ? 'text' : 'password'"
                  :append-icon="mostrarPassword ? 'mdi-eye-off' : 'mdi-eye'"
                  @click:append="mostrarPassword = !mostrarPassword"
                  :disabled="cargando"
                  @keyup.enter="iniciarSesion"
                  hide-details class="mb-4"
                />

                <v-alert v-if="error" type="error" dense text class="mb-3">{{ error }}</v-alert>

                <v-btn
                  color="primary" x-large block rounded
                  :loading="cargando" @click="iniciarSesion"
                  elevation="4" class="mb-3"
                >
                  <v-icon left>mdi-login</v-icon>
                  Ingresar
                </v-btn>
              </v-form>
            </v-card-text>

            <!-- ── PASO 2: Código 2FA ── -->
            <v-card-text v-if="requiere2FA" class="px-4 py-3">
              <div class="text-center mb-4">
                <v-icon color="primary" size="56">mdi-shield-lock</v-icon>
                <div class="text-h6 font-weight-bold mt-1">Verificación en dos pasos</div>
                <div class="text-caption grey--text">Abre tu app de autenticación (Google Authenticator, etc.) y escribe el código de 6 dígitos</div>
              </div>

              <v-text-field
                v-model="codigo2FA"
                label="Código de 6 dígitos"
                outlined rounded
                prepend-inner-icon="mdi-numeric"
                maxlength="6"
                type="text"
                inputmode="numeric"
                pattern="[0-9]*"
                autofocus
                :disabled="cargando"
                @keyup.enter="verificar2FA"
                hide-details class="mb-4"
                style="letter-spacing:8px; font-size:22px; font-family:monospace;"
              />

              <v-alert v-if="error" type="error" dense text class="mb-3">{{ error }}</v-alert>

              <v-btn color="primary" x-large block rounded :loading="cargando" @click="verificar2FA" elevation="4" class="mb-2">
                <v-icon left>mdi-shield-check</v-icon> Verificar
              </v-btn>
              <v-btn text block small @click="requiere2FA = false; error = ''">
                <v-icon left small>mdi-arrow-left</v-icon> Volver al login
              </v-btn>
            </v-card-text>

            <div class="text-center pb-4 text-caption grey--text">
              GymPro · By: Dvarela
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import HttpService from '../../Servicios/HttpService'
import Utiles from '../../Servicios/Utiles'

export default {
  name: 'Login',
  data: function() {
    return {
      usuario: '',
      password: '',
      mostrarPassword: false,
      cargando: false,
      error: '',
      nombreGimnasio: '',
      logo: '',
      // 2FA
      requiere2FA: false,
      idUsuarioPendiente: null,
      codigo2FA: '',
      // Datos guardados del paso 1 para el paso 2
      _datosEspera: null,
    }
  },

  mounted: function() {
    this.nombreGimnasio = localStorage.getItem('nombreGimnasio') || ''
    var logoRaw = localStorage.getItem('logoGimnasio') || ''
    this.logo = logoRaw ? Utiles.generarURL(logoRaw) : ''
  },

  methods: {
    iniciarSesion: function() {
      if (!this.usuario || !this.password) {
        this.error = 'Escribe tu usuario y contraseña'
        return
      }
      this.cargando = true
      this.error = ''
      var self = this

      HttpService.login({ usuario: this.usuario, password: this.password })
        .then(function(respuesta) {
          self.cargando = false
          if (!respuesta) {
            self.error = 'Error de conexión. Intenta de nuevo.'
            return
          }

          // El usuario tiene 2FA activo
          if (respuesta.resultado === 'requiere_2fa') {
            self.requiere2FA = true
            self.idUsuarioPendiente = respuesta.idUsuario
            self._datosEspera = respuesta
            return
          }

          // Login normal (sin 2FA)
          if (!respuesta.resultado) {
            self.error = respuesta.error || 'Usuario o contraseña incorrectos'
            return
          }

          self.$emit('logeado', respuesta)
        })
        .catch(function() {
          self.cargando = false
          self.error = 'Error de conexión con el servidor'
        })
    },

    verificar2FA: function() {
      var codigo = String(this.codigo2FA).trim()
      if (!codigo || codigo.length < 6) {
        this.error = 'Escribe el código de 6 dígitos de tu app autenticadora'
        return
      }
      this.cargando = true
      this.error = ''
      var self = this

      HttpService.obtenerConDatos({
        metodo: 'verificar_2fa',
        idUsuario: this.idUsuarioPendiente,
        codigo: codigo,
      }, 'auth.php').then(function(respuesta) {
        self.cargando = false
        if (!respuesta) {
          self.error = 'Error de conexión. Intenta de nuevo.'
          return
        }
        if (!respuesta.resultado) {
          self.error = respuesta.error || 'Código incorrecto o expirado'
          self.codigo2FA = ''
          return
        }
        self.$emit('logeado', respuesta)
      }).catch(function() {
        self.cargando = false
        self.error = 'Error de conexión'
      })
    },

    bubbleStyle: function(i) {
      var sizes   = [80, 120, 60, 200, 100, 160, 40, 90]
      var tops    = [10, 70, 30, 50, 80, 20, 60, 40]
      var lefts   = [5, 20, 60, 80, 40, 70, 10, 90]
      var delays  = [0, 2, 4, 1, 5, 3, 6, 7]
      var s = sizes[i - 1] + 'px'
      return {
        width: s, height: s,
        top: tops[i - 1] + '%',
        left: lefts[i - 1] + '%',
        animationDelay: delays[i - 1] + 's',
        animationDuration: (10 + i * 1.5) + 's',
      }
    },
  },
}
</script>

<style scoped>
.login-bg {
  background: linear-gradient(135deg, #0a0a2e 0%, #1706FF 50%, #0D47A1 100%);
  min-height: 100vh;
  position: relative;
  overflow: hidden;
}
.login-animated-bg { position: absolute; inset: 0; overflow: hidden; pointer-events: none; }
.bubble {
  position: absolute;
  border-radius: 50%;
  background: rgba(255,255,255,0.04);
  animation: flotar 12s infinite ease-in-out;
}
@keyframes flotar {
  0%, 100% { transform: translateY(0) scale(1); }
  50%       { transform: translateY(-30px) scale(1.05); }
}
.glass-card {
  background: rgba(255,255,255,0.95) !important;
  backdrop-filter: blur(20px);
}
</style>


// WEBPACK FOOTER //
// src/components/Usuarios/Login.vue